// Favre — napisy na filmie hero (spec: Downloads/MILKY-HERO-SPEC.md, 2026-10-15).
// Czasy i pozycje (ułamki kadru 16:9) są wspólne dla wszystkich języków; teksty przychodzą
// z locales/*.json przez Liquid (data-favre-cues). Aktywny cue: pierwszy z start ≤ t < end.
// requestAnimationFrame w czasie odtwarzania (samo timeupdate odpala ~4×/s — fade by się spóźniał).
(() => {
  document.querySelectorAll('[data-favre-captions]').forEach((layer) => {
    const hero = layer.closest('[data-favre-hero]');
    const video = hero?.querySelector('.favre-hero__video');
    const dataEl = hero?.querySelector('[data-favre-cues]');
    if (!video || !dataEl) return;

    let cues = [];
    try {
      cues = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    const box = layer.querySelector('.favre-cap');
    const media = layer.parentElement;
    const header = document.querySelector('.section-header');
    const proof = hero.querySelector('.favre-hero__proof');
    const glas = hero.querySelector('.favre-glas--na-filmie');

    // Warstwa = prostokąt CAŁEGO kadru 16:9 przy object-fit: cover (część wystaje poza ekran).
    // Dzięki temu pozycje ze specu (ułamki kadru) trafiają w to samo miejsce obrazu przy każdym rozmiarze.
    const dopasuj = () => {
      const W = media.clientWidth;
      const H = media.clientHeight;
      if (!W || !H) return;
      const ar = (video.videoWidth && video.videoHeight) ? video.videoWidth / video.videoHeight : (window.matchMedia('(max-width: 749px)').matches ? 9 / 16 : 16 / 9);
      const pos = (getComputedStyle(video).objectPosition || '50% 50%').split(' ').map((v) => parseFloat(v) / 100);
      let fw = W, fh = W / ar;
      if (fh < H) { fh = H; fw = H * ar; }
      const left = (W - fw) * (isNaN(pos[0]) ? 0.5 : pos[0]);
      const top = (H - fh) * (isNaN(pos[1]) ? 0.5 : pos[1]);
      Object.assign(layer.style, { left: `${left}px`, top: `${top}px`, width: `${fw}px`, height: `${fh}px`, right: 'auto', bottom: 'auto' });
      // Limity napisu (pod menu, nad dolną krawędzią ekranu) mierzone TYLKO na górze strony i zapamiętane.
      // Nagłówek jest sticky, a pasek Safari zmienia wysokość okna w trakcie przewijania — pomiar po przewinięciu
      // dawał inne liczby i po powrocie na górę napisy stały gdzie indziej niż na starcie (zgłoszenie 2026-10-16).
      if (window.scrollY < 5 || !limity) {
        const mediaTop = media.getBoundingClientRect().top + window.scrollY;
        const headerBottom = header && window.scrollY < 5 ? header.getBoundingClientRect().bottom + window.scrollY : mediaTop;
        const widoczny = window.visualViewport ? window.visualViewport.height : window.innerHeight;
        limity = {
          // najmniejsza odległość od góry kadru: pod paskiem menu (gdy nagłówek nachodzi na film)
          gora: Math.max(0, headerBottom - mediaTop) + 18,
          // dół napisu nad dolnym paskiem przeglądarki (iPhone: pasek Safari nachodzi na stronę), liczony od góry hero
          // i nad plakietką opinii na dole hero (.favre-hero__proof), jeśli jest
          dol: Math.min(
            widoczny - 28 - (hero.getBoundingClientRect().top + window.scrollY),
            proof ? proof.getBoundingClientRect().top - hero.getBoundingClientRect().top - 14 : Infinity
          ),
          naGorze: window.scrollY < 5,
        };
      }
      layer.style.setProperty('--cap-min-top', `${limity.gora - top}px`);
    };
    let limity = null;
    dopasuj();
    // strona otwarta w połowie (przywrócone przewinięcie) → limity tymczasowe; dokładne przy pierwszym powrocie na górę
    window.addEventListener('scroll', () => {
      if (window.scrollY < 5 && limity && !limity.naGorze) dopasuj();
    }, { passive: true });
    window.addEventListener('resize', dopasuj, { passive: true });
    video.addEventListener('loadedmetadata', dopasuj);
    if (window.ResizeObserver) new ResizeObserver(dopasuj).observe(media);
    const h = box.querySelector('.favre-cap__h');
    const s = box.querySelector('.favre-cap__s');
    let aktywny = -1;
    let raf = 0;

    const pokaz = (i) => {
      if (i === aktywny) return;
      aktywny = i;
      if (i < 0) {
        box.classList.remove('is-visible');
        return;
      }
      const c = cues[i];
      const ustaw = () => {
        h.textContent = c.h;
        s.textContent = c.s;
        const tel = window.matchMedia('(max-width: 749px)').matches;
        box.style.left = `${(tel ? c.mx : c.x) * 100}%`;
        box.style.top = `${(tel ? c.my : c.y) * 100}%`;
        // nie pod menu: jeśli górna krawędź napisu wypada nad dolną krawędzią nagłówka — zsuń w dół
        box.style.marginTop = '0px';
        box.style.marginLeft = '0px';
        // telefon: kadr 9:16 jest szerszy niż ekran (cover) — szerokość napisu = najwyżej widoczny ekran − marginesy
        box.style.maxWidth = tel ? `${Math.min(layer.clientWidth * 0.72, media.clientWidth - 2 * 16)}px` : '';
        requestAnimationFrame(() => {
          const min = parseFloat(layer.style.getPropertyValue('--cap-min-top')) || 0;
          const gora = box.offsetTop - box.offsetHeight / 2;
          if (gora < min) box.style.marginTop = `${min - gora}px`;
          // dół napisu nad dolnym paskiem przeglądarki — limit zapamiętany na górze strony, więc pozycja
          // jest taka sama niezależnie od tego, czy napis pojawił się w trakcie przewijania
          const dolNapisu = box.getBoundingClientRect().bottom - hero.getBoundingClientRect().top;
          if (limity && dolNapisu > limity.dol) {
            box.style.marginTop = `${(parseFloat(box.style.marginTop) || 0) - (dolNapisu - limity.dol)}px`;
          }
          // szklany panel na filmie (desktop, prawy górny róg): napis, który by na niego wszedł, odsuwa się w lewo
          if (glas && glas.offsetParent) {
            const g = glas.getBoundingClientRect(), r = box.getBoundingClientRect();
            if (r.left < g.right + 24 && r.right > g.left - 24 && r.top < g.bottom + 16 && r.bottom > g.top - 16) {
              box.style.marginLeft = `${-(r.right - (g.left - 32))}px`;
            }
          }
          // napis zawsze w widocznej części ekranu (kadr przy cover wystaje poza ekran po bokach)
          const m = media.getBoundingClientRect(), r2 = box.getBoundingClientRect(), pad = tel ? 16 : 24;
          const ml = parseFloat(box.style.marginLeft) || 0;
          if (r2.left < m.left + pad) box.style.marginLeft = `${ml + (m.left + pad - r2.left)}px`;
          else if (r2.right > m.right - pad) box.style.marginLeft = `${ml - (r2.right - (m.right - pad))}px`;
        });
        box.classList.toggle('favre-cap--waski', !!c.waski && !tel);
        box.classList.toggle('favre-cap--prawo', c.x >= 0.5);
        box.classList.add('is-visible');
      };
      // poprzedni napis jeszcze widoczny → krótkie wygaszenie, potem nowy
      if (box.classList.contains('is-visible')) {
        box.classList.remove('is-visible');
        setTimeout(() => { if (aktywny === i) ustaw(); }, 250);
      } else {
        ustaw();
      }
    };

    const sprawdz = () => {
      const t = video.currentTime;
      // mx < 0 = napis ukryty na telefonie (np. 360° nad wzorem krowy — nieczytelny, decyzja usera 2026-10-19)
      const tel = window.matchMedia('(max-width: 749px)').matches;
      pokaz(cues.findIndex((c) => t >= c.start && t < c.end && !(tel && c.mx < 0)));
    };

    const petla = () => {
      sprawdz();
      if (!video.paused) raf = requestAnimationFrame(petla);
    };

    video.addEventListener('timeupdate', sprawdz);
    video.addEventListener('playing', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(petla);
    });
    video.addEventListener('pause', () => cancelAnimationFrame(raf));
    video.addEventListener('seeked', sprawdz);
  });
})();
